import React, { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { userSettingsStore } from '@pascal/pascal-core';
import { Decimal } from 'decimal.js';
import { kenoBetStore } from '../../store/kenoBetStore';
import { userInfoStore } from '../../store/userInfoStore';
import NotTicket from '../notTicket';
import useTranslation from '../../hooks/useTranslation';
import { parseNumberPrecisionByDoteCount } from '../../core/helpers/parseNumberByPrecision';
import TicketWrapper from '../ticketWrapper';
import { soundService } from '../../services/baseSoundService';
import TicketTitle from '../ticketTitle';
import { applicationStore } from '../../store/applicationStore';
import { DEMO_GAME_CURRENCY } from '../../core/constants/gameConstants';

const BetSlip = observer(() => {
  const {
    tickets,
    deleteTicket,
    winNumbers,
    isBetsClosed,
    setTickets,
    totalWinAmount,
    winNumbersForTickets,
  } = kenoBetStore;
  const { currencyCode, precision } = userInfoStore;
  const { isSoundOn } = userSettingsStore;
  const { isDemo } = applicationStore;
  const t = useTranslation();

  const handleDeleteTicket = useCallback(
    (id) => {
      deleteTicket(id);
      if (isSoundOn) {
        soundService.playClearDelete();
      }
    },
    [deleteTicket, isSoundOn]
  );

  const handleClearAllTickets = useCallback(() => {
    setTickets([]);
    if (isSoundOn) {
      soundService.playClearDelete();
    }
  }, [setTickets, isSoundOn]);

  const totalTicketAmount = useMemo(() => {
    const amount = tickets.reduce((acc, current) => {
      return acc.plus(current.amount);
    }, new Decimal(0));
    return parseNumberPrecisionByDoteCount(amount.valueOf(), 1, precision);
  }, [tickets, precision]);

  const sortedTickets = useMemo(() => {
    if (!isBetsClosed) {
      return [...tickets].sort((a, b) => b.winAmount - a.winAmount);
    }
    return [...tickets].sort(
      (a, b) =>
        b.numbers.filter((el) => winNumbers.includes(el)).length -
        a.numbers.filter((el) => winNumbers.includes(el)).length
    );
  }, [tickets, winNumbers, isBetsClosed]);

  return (
    <div className='betslip-tickets-wrapper'>
      {tickets.length ? (
        <div className='betslip-tickets-content'>
          <TicketTitle
            t={t}
            tickets={tickets}
            isBetsClosed={isBetsClosed}
            currencyCode={isDemo ? DEMO_GAME_CURRENCY : currencyCode}
            handleClearAllTickets={handleClearAllTickets}
            totalTicketAmount={totalTicketAmount}
            totalTicketsWinAmount={totalWinAmount}
          />
          <TicketWrapper
            t={t}
            tickets={sortedTickets}
            isBetsClosed={isBetsClosed}
            currencyCode={isDemo ? DEMO_GAME_CURRENCY : currencyCode}
            winNumbersForTickets={winNumbersForTickets}
            handleDeleteTicket={handleDeleteTicket}
          />
        </div>
      ) : (
        <NotTicket t={t} />
      )}
    </div>
  );
});
export default BetSlip;
